import React, { ReactNode, useState, useRef, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import OurApproachIcon from '../../assets/icons/OurApproachIcon';

type TOurApproachCard = {
    text: string;
    icon: ReactNode;
    icon2: ReactNode;
    icon3: ReactNode;
    iconBackground: string;
    description1: string;
    description2: string;
    background2: string;
    id: number;
};

const OurApproachCard = ({
    id,
    text,
    icon,
    icon2,
    icon3,
    iconBackground,
    description1,
    description2,
    background2
}: TOurApproachCard) => {
    const [showFullCard, setShowFullCard] = useState(false);
    const handleMouseOver = () => {
        setShowFullCard(true);
    };
    const handleMouseOut = () => {
        setShowFullCard(false);
    };

    const targetRef = useRef(null);

    useEffect(() => {
        const targetDiv = targetRef?.current;

        // Create an Intersection Observer instance
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setShowFullCard(true);
                    } else setShowFullCard(false);
                });
            },
            {
                root: null, // Use the viewport as the root
                rootMargin: '0px',
                threshold: 0 // Trigger when 10% of the div is in view
            }
        );

        // Start observing the target div
        if (targetDiv) {
            observer.observe(targetDiv);
        }

        // Clean up the observer when the component is unmounted
        return () => {
            if (targetDiv) {
                observer.unobserve(targetDiv);
            }
        };
    }, []);
    return (
        <>
            <Box
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                sx={{
                    transition: 'all .9s ease',
                    // transitionDelay: '250ms',
                    display: { xs: 'none', sm: 'flex' },
                    height: showFullCard ? 'fit-content' : '250px',
                    width: '100%',
                    padding: showFullCard ? '18px 20px' : '40px 20px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    gap: showFullCard ? '16px' : '8px',
                    alignSelf: 'stretch',
                    borderRadius: '20px',
                    border: showFullCard
                        ? '1px solid #EFFDF5'
                        : '1px solid #FFF',
                    background: showFullCard
                        ? background2
                        : 'linear-gradient(227deg, #FFF -0.45%, rgba(255, 255, 255, 0.00) 109.28%)',
                    position: 'relative'
                    // opacity: !showFullCard ? "0" : "1",
                    // visibility: !showFullCard ? "hidden" : "visible",
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: showFullCard ? 'row' : 'column',
                        gap: showFullCard ? '8px' : '16px',
                        alignItems: showFullCard ? 'center' : 'flex-start',
                        transition: 'all .9s ease-in-out'
                        // transitionDelay: '250ms'
                    }}
                >
                    <Box
                        sx={{
                            transition: 'all .9s ease'
                            // transitionDelay: '250ms'
                        }}
                    >
                        <Box
                            sx={{
                                transition: 'all .9s ease',
                                // transitionDelay: '250ms',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: showFullCard ? '76px' : '80px',
                                height: showFullCard ? '76px' : '80px',
                                bgcolor: showFullCard
                                    ? 'transparent'
                                    : iconBackground,
                                borderRadius: showFullCard ? 0 : '100%'
                            }}
                        >
                            {showFullCard ? icon3 : icon}
                            {/* <Box sx={{width:'80px', height:'80px', }}>
                        <OurApproachIcon background={FullCard}/>
                    </Box> */}
                        </Box>
                        {!showFullCard && (
                            <Box
                                position="absolute"
                                sx={{
                                    top: 0,
                                    right: 0,
                                    transition: 'all .9s ease'
                                    // transitionDelay: '250ms'
                                }}
                            >
                                {icon2}
                            </Box>
                        )}
                        {/* <Box>
                    <img src={img} alt="peertopeer"/>
                </Box> */}
                    </Box>

                    <Box
                        sx={{
                            maxWidth: '389px',
                            transition: 'all .9s ease'
                            // transitionDelay: '250ms'
                        }}
                    >
                        <Typography
                            className="text"
                            sx={{
                                color: '#23282B',
                                // fontFamily: 'space-grotesk',
                                fontSize: { xs: '24px', sm: '32px' },
                                fontStyle: 'normal',
                                fontWeight: '800',
                                lineHeight: '120%',
                                letterSpacing: '-0.64px',
                                textTransform: 'capitalize',
                                transition: 'all .9s ease'
                                // transitionDelay: '250ms'
                            }}
                        >
                            {text}
                        </Typography>
                    </Box>
                </Box>
                {showFullCard && (
                    <Box
                        display="flex"
                        sx={{
                            flexDirection: 'column',
                            gap: '20px',
                            transition: 'all .9s ease'
                            // transitionDelay: '250ms'
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '14px',
                                color: '#333',
                                transition: 'all .9s ease'
                                // transitionDelay: '250ms'
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    color: '#23282b',
                                    display: 'inline'
                                }}
                            >
                                For Job Seekers:{' '}
                            </Typography>
                            {description1}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                color: '#333',
                                transition: 'all .9s ease'
                                // transitionDelay: '250ms'
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    color: '#23282b',
                                    display: 'inline'
                                }}
                            >
                                For Employers:{' '}
                            </Typography>
                            {description2}
                        </Typography>
                    </Box>
                )}
            </Box>
            <Box
                ref={targetRef}
                sx={{
                    transition: 'all .7s ease',
                    // transitionDelay: '250ms',
                    display: { xs: 'flex', sm: 'none' },
                    height: showFullCard ? 'fit-content' : '250px',
                    width: '100%',
                    padding: showFullCard ? '18px 20px' : '40px 20px',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    gap: showFullCard ? '16px' : '8px',
                    alignSelf: 'stretch',
                    borderRadius: '20px',
                    border: showFullCard
                        ? '1px solid #EFFDF5'
                        : '1px solid #FFF',
                    background: showFullCard
                        ? background2
                        : 'linear-gradient(227deg, #FFF -0.45%, rgba(255, 255, 255, 0.00) 109.28%)',
                    position: 'relative'
                    // opacity: !showFullCard ? "0" : "1",
                    // visibility: !showFullCard ? "hidden" : "visible",
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: showFullCard ? 'row' : 'column',
                        gap: showFullCard ? '8px' : '16px',
                        alignItems: showFullCard ? 'center' : 'flex-start',
                        transition: 'all .7s ease-in-out'
                        // transitionDelay: '250ms'
                    }}
                >
                    <Box
                        sx={{
                            transition: 'all .7s ease'
                            // transitionDelay: '250ms'
                        }}
                    >
                        <Box
                            sx={{
                                transition: 'background .1s ease',
                                // transitionDelay: '250ms',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: showFullCard ? '76px' : '80px',
                                height: showFullCard ? '76px' : '80px',
                                bgcolor: showFullCard
                                    ? 'transparent'
                                    : iconBackground,
                                borderRadius: showFullCard ? 0 : '100%'
                            }}
                        >
                            {showFullCard ? icon3 : icon}
                            {/* <Box sx={{width:'80px', height:'80px', }}>
                        <OurApproachIcon background={FullCard}/>
                    </Box> */}
                        </Box>
                        {!showFullCard && (
                            <Box
                                position="absolute"
                                sx={{
                                    top: 0,
                                    right: 0,
                                    transition: 'all .7s ease'
                                    // transitionDelay: '250ms'
                                }}
                            >
                                {icon2}
                            </Box>
                        )}
                        {/* <Box>
                    <img src={img} alt="peertopeer"/>
                </Box> */}
                    </Box>

                    <Box
                        sx={{
                            maxWidth: '389px',
                            transition: 'all .7s ease'
                            // transitionDelay: '250ms'
                        }}
                    >
                        <Typography
                            className="text"
                            sx={{
                                color: '#23282B',
                                // fontFamily: 'space-grotesk',
                                fontSize: { xs: '24px', sm: '32px' },
                                fontStyle: 'normal',
                                fontWeight: '800',
                                lineHeight: '120%',
                                letterSpacing: '-0.64px',
                                textTransform: 'capitalize',
                                transition: 'all .7s ease'
                                // transitionDelay: '250ms'
                            }}
                        >
                            {text}
                        </Typography>
                    </Box>
                </Box>
                {showFullCard && (
                    <Box
                        display="flex"
                        sx={{
                            flexDirection: 'column',
                            gap: '20px',
                            transition: 'all .7s ease'
                            // transitionDelay: '250ms'
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '14px',
                                color: '#333',
                                transition: 'all .7s ease'
                                // transitionDelay: '250ms'
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    color: '#23282b',
                                    display: 'inline'
                                }}
                            >
                                For Job Seekers:{' '}
                            </Typography>
                            {description1}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                color: '#333',
                                transition: 'all .7s ease'
                                // transitionDelay: '250ms'
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    color: '#23282b',
                                    display: 'inline'
                                }}
                            >
                                For Employers:{' '}
                            </Typography>
                            {description2}
                        </Typography>
                    </Box>
                )}
            </Box>
        </>
    );
};
export default OurApproachCard;
